<template>
	<el-dialog title="发送小程序链接" :visible.sync="dialogVisibles" width="30%" :before-close="handleClose">
		<span>选择推荐的小程序</span>
		<div class="linklist">
			<el-checkbox-group v-model="checkList">
				<el-checkbox v-for="item in datas" :label="item.id" :key="item.id">
					<img :src="item.logoUrl" />
					{{item.miniName}}
				</el-checkbox>
			</el-checkbox-group>
		</div>
		<span slot="footer" class="dialog-footer" center="true">
			<el-button @click="handleClose">取 消</el-button>
			<el-button type="primary" @click="onSubmit">确 定</el-button>
		</span>
	</el-dialog>
</template>
<script>
import { getMiniSendMessage } from './ViewModel'
export default {
	name: 'miniMessage',
	data() {
		return {
			dialogVisibles: false,
			datas: [],
			checkList: []
		}
	},
	props: {
		dialogVisible: {
			type: Boolean,
			default: false
		},
		data: {
			type: Array,
			default: () => []
		},
		currentObj: {
			type: Object,
			default: {}
		}
	},
	watch: {
		dialogVisible: function(val) {
			this.dialogVisibles = val
		},
		data: function(val) {
			console.log(val)
			this.datas = val
		},
		checkList: function(val) {
			console.log(val)
		}
	},
	methods: {
		handleClose(done) {
			this.dialogVisibles = false
			this.$emit('close', false)
		},
		onSubmit() {
			let vm = this
			vm.checkList.forEach(item => {
				var obj = {}
				var arr = []
				let str = vm.datas.find(d => d.id == item)
				let miniObj = getMiniSendMessage(
					vm.currentObj,
					5,
					str.appId,
					str.path,
					'点击跳转【' + str.miniName + '】'
				)
				if (str.sulfJump) {
					miniObj.messageType = 7
				}
				arr.push(miniObj)
				obj.Receiver = vm.currentObj.consultId
				obj.conversationLogId = vm.currentObj.conversationLogId
				obj.dialogues = arr
				vm.$emit('sendMiniMessage', obj)
			})
			this.handleClose()
		}
	}
}
</script>
<style scoped>
.linklist {
	margin-top: 20px;
}
.el-checkbox {
	margin-top: 10px;
}
.linklist img {
	width: 30px;
	height: 30px;
	vertical-align: middle;
}
</style>


// WEBPACK FOOTER //
// src/components/customer/talks/miniMessage.vue